import validator from 'validator';

/**
 * Validates a postal code.
 * Checks against the UK (GB) format first, and falls back to a global validation check.
 * 
 * @param {string} postcode - The postal code to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidPostalCode = (postcode, country = "") => {
  if (!postcode || typeof postcode !== 'string') {
    return false;
  }
  
  const trimmed = postcode.trim();
  if (trimmed === "") {
    return false;
  }

  // Country specific validations
  if (country) {
    const lowerCountry = country.toLowerCase();
    
    // Sri Lanka: 5 digits, valid prefixes based on districts
    if (lowerCountry === 'sri lanka') {
      const slRegex = /^(00|01|10|11|12|20|21|22|30|31|32|40|41|42|43|44|50|51|60|61|70|71|80|81|82|90|91)\d{3}$/;
      return slRegex.test(trimmed);
    }
    
    // United Kingdom
    if (lowerCountry === 'united kingdom' || lowerCountry === 'uk' || lowerCountry === 'gb') {
      return validator.isPostalCode(trimmed, 'GB');
    }
  }

  // Validate as UK post code
  if (validator.isPostalCode(trimmed, 'GB')) {
    return true;
  }

  // Validate as generic global post code
  // 'any' locale checks against all known formats in the validator library
  if (validator.isPostalCode(trimmed, 'any')) {
    return true;
  }

  return false;
};
